module.exports = __webpack_public_path__ + "static/img-main-e6dcecc60508194acc79924876f7ab4a.jpg";